import React from "react";
import { FaThumbtack, FaTimes } from "react-icons/fa";
import "./PinMessageModal.css";

const PinMessageModal = ({ message, onConfirm, onClose, isUnpin = false }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content pin-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>
            <FaThumbtack /> {isUnpin ? "Unpin Message" : "Pin Message"}
          </h3>
          <button onClick={onClose} className="btn-close-modal">
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <p>
            {isUnpin
              ? "Are you sure you want to unpin this message?"
              : "Pin this message so it stays at the top of the chat?"}
          </p>

          {message.content && (
            <div className="message-preview">
              <p>"{message.content.substring(0, 100)}..."</p>
              <small>by {message.sender?.name || "Unknown"}</small>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="btn-cancel">
            Cancel
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="btn-confirm"
          >
            {isUnpin ? "Unpin" : "Pin Message"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PinMessageModal;
